import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './ErrorBoundary';

const demoConfig = {
  enabled: process.env.REACT_APP_DEMO_MODE === 'true',
  username: process.env.REACT_APP_DEMO_USERNAME || '',
  password: process.env.REACT_APP_DEMO_PASSWORD || '',
  tooltip: process.env.REACT_APP_DEMO_TOOLTIP || 'This live demo is read-only and resets nightly.'
};

// Always set demo mode if enabled (for runtime detection)
if (typeof window !== 'undefined') {
  if (demoConfig.enabled) {
    window.__DEMO_MODE__ = true;
    window.__DEMO_USERNAME__ = demoConfig.username;
    window.__DEMO_PASSWORD__ = demoConfig.password;
    window.__DEMO_TOOLTIP__ = demoConfig.tooltip;
    console.log('[Demo] Demo mode enabled via REACT_APP_DEMO_MODE');
  }
  
  // Also check URL parameter for demo mode (useful for testing)
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('demo') === 'true') {
    window.__DEMO_MODE__ = true;
    window.__DEMO_TOOLTIP__ = window.__DEMO_TOOLTIP__ || demoConfig.tooltip;
    window.__DEMO_USERNAME__ = window.__DEMO_USERNAME__ || demoConfig.username;
    window.__DEMO_PASSWORD__ = window.__DEMO_PASSWORD__ || demoConfig.password;
    console.log('[Demo] Demo mode enabled via URL parameter');
  }
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('Root element not found!');
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>
  );
}

